<template>
  <div :class="'option-list ' + inputName">
    <Infobox :data="infobox" :opened="isInfoboxOpen" v-on:close-infobox="isInfoboxOpen = false">
    </Infobox>
    <table>
      <tr v-for="option in tmpOpt" v-bind:key="option.name" :class="getTrClass(option)">
        <td style="width: 70%">
          <label class="general-title" :class="{ active: option.name == getCurrentValue() }">
            <input type="radio" :name="inputName" :value="option" v-model="targetAttribute" style="display: none"
              :data-is-electronic="option.is_electronic" />{{ option.name }}
            <img style="
                  vertical-align: baseline;
                  margin-left: 5px;
                  filter: opacity(0.5);
                  width: 16px;
                " src="/configurator/chip-icon.png" alt="" v-if="option.is_electronic"
              :id="'electronic-component-icon' + option.id" /></label>

          <b-popover :target="'electronic-component-icon' + option.id" triggers="hover" placement="top"
            v-if="option.is_electronic">
            <template #title>Electronic component</template>
          </b-popover>
        </td>
        <td style="text-align: center">
          <span class="price" v-if="
            option.price != 0 && option.price != '' && option.price != null
          ">+ &euro;{{ option.price }}</span>
        </td>
        <td>
          <img style="cursor: pointer" src="/configurator/info-icon.svg" alt="More informations"
            v-on:click="openInfobox(option.description, option.name, option.image, option.gallery)"
            v-if="option.id != -1 && option.description != ''" />
        </td>
      </tr>
    </table>

    <div class="measures-wrapper" v-if="measureLabel">
      <div class="measures mt-5" v-for="option in this.options" v-bind:key="option.name">
        <div v-if="showMeasures(option)" :class="option.id == '40' ? 'is_alanera' : ''">
          <div class="uppercase xs-text bold mb-1">{{ measureLabel }}</div>
          <label class="measure" v-for="measure in getMeasures(option.measures)" v-bind:key="measure"
            :class="{ active: measures[inputName] == measure }">
            {{ measure }}
            <input type="radio" :name="'measure_' + inputName" :id="'measure_' + inputName" v-model="measuresModel"
              :value="measure" style="display: none" />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Infobox from './infobox';
export default {
  name: "option-list",
  components: {
    Infobox
  },
  data() {
    return {
      tmpOpt: null,
      isInfoboxOpen: false,
      infobox: {
        title: null,
        text: null,
        image: null,
        gallery: null,
      }
    };
  },
  props: [
    "options",
    "target",
    "inputName",
    "measureLabel",
    "results",
    "targetMeasure",
    "measures",
    "electronicMode",
    "hideNoOptionButton",
    "bikeConfiguration"
  ],
  mounted: function () {
    this.tmpOpt = this.options;
    if (this.hideNoOptionButton) {
      this.tmpOpt.splice(-1);
    }
  },
  computed: {
    targetAttribute: {
      get: function () {
        return this.target;
      },
      set: function (e) {
        this.$emit("target-updated", e, this.inputName);
      },
    },
    measuresModel: {
      get: function () {
        if (this.target == null || typeof this.target.measure == "undefined") {
          return null;
        }
        return this.target.measure;
      },
      set: function (e) {
        this.$emit("update-measures", e);
      },
    },
    notNullOptions: function () {
      return this.options.filter((e) => {
        if (e.id != -1) return e;
      });
    },
    nullOptions: function () {
      return this.options.filter((e) => {
        if (e.id == -1) return e;
      })[0];
    },
  },
  methods: {
    getCurrentValue: function () {
      if (
        typeof this.target != "undefined" &&
        this.target != null &&
        typeof this.target.name != "undefined"
      ) {
        return this.target.name;
      } else if (typeof this.target != "undefined") {
        return this.target;
      }
      return null;
    },
    getMeasures: function (measures) {
      if (typeof measures == "undefined") {
        return [];
      }
      if (!measures.includes(",")) {
        return [measures];
      }
      let ret = [];
      let splitted = measures.split(",");
      for (let i = 0; i < splitted.length; i++) {
        ret.push(splitted[i].trim());
      }
      return ret;
    },
    setMeasures: function (e) {
      this.$emit("update-measures", e);
    },
    showMeasures: function (option) {
      if (this.results[this.inputName] == null) {
        return false;
      }
      let optionName = option.name;
      if (option.measures == null || option.measures.length == 0) {
        return false;
      }
      if (
        typeof this.targetAttribute == "undefined" ||
        this.targetAttribute == null
      ) {
        return false;
      }
      return this.targetAttribute.name == optionName;
    },
    openInfobox: function (text, title, image, gallery) {

      if (image != null) {
        image = window.mainSite + 'storage/' + image;
      }

      this.infobox.title = title;
      this.infobox.text = text;
      this.infobox.image = image;
      //this.infobox.gallery = gallery;
      this.isInfoboxOpen = true;
      /*
      this.$bvModal.show("infobox");

      setTimeout(function () {
        console.log("window.bikeConfigurationData");
        console.log(window.bikeConfigurationData);

        document.querySelector("#infobox .modal-title").innerHTML = title;
        document.querySelector("#infobox .modal-body").innerHTML = text;
        document.getElementById("infobox").classList.add("infoboxSideRight");
        document.querySelector("#infobox .modal-dialog").classList.remove("modal-dialog-centered");
        document.querySelector("#infobox .modal-dialog").classList.add("modal-dialog-right");
        document.getElementById("infobox").classList.add("right");
      }, 100);
      */
    },
    getTrClass: function (option) {
      let a = { active: option.name == this.getCurrentValue() };
      let vname = "option-" + option.id;
      a[vname] = vname;
      return a;
    },
  },
  watch: {
    options: {
      handler(newValue) {
        this.tmpOpt = this.options;
        if (this.hideNoOptionButton) {
          this.tmpOpt.splice(-1);
        }
      },
      deep: true
    }
  },
};
</script>

<style lang="scss" scoped>
.is_alanera {
  label {
    width: 60px;
    height: 60px;
    margin-right: 40px;
    margin-bottom: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.option-list {
  label {
    cursor: pointer;
  }

  table {
    width: 100%;

    td {
      padding: 7px 0;
    }

    .general-title {
      font-weight: 400;
      color: #888;
      font-size: 18px;
      line-height: 22px;

      &.active {
        color: black;
      }
    }

    .price {
      font-size: 16px;
      color: #888;
    }

    img {
      width: 20px;
    }

    .active {
      color: black;

      .price {
        color: black;
      }
    }
  }
}

.crankset {
  /*
  table{
    tr{
      display: none;
      &.active, &.related-active, &.option-81, &.option-104 {
        display: table-row;
      }
    }
  }
  */
  /*
  label {
    display: none;
  }
  label.active,
  label.related-active {
    display: inline-block;
  }
  .option-81 {
    label {
      display: inline-block;
    }
  }
  .option-104 {
    label {
      display: inline-block;
    }
  }
  */
}
</style>

